<div
  [id]="mapConfig.id"
  [class]="'location-map ' + andClass"
  [ngStyle]="{
    height: mapConfig.height === '100%' ? mapConfig.height : mapConfig.height + 'px',
    'pointer-events': mapConfig.scrollable ? 'auto' : 'none',
    filter: mapConfig.grayscale ? 'grayscale(100%)' : 'none',
  }"></div>

<div id="popup"></div>
